$(document).ready(function () {

    // Initial setup.
    $(".tabs-controls a").first().addClass("active");
    $(".tabs-wrapper .tab").first().show();

    $(".tabs-controls a").click(function (e) {
        e.preventDefault();
        var targetId = $(this).attr("href");
        var target = $(targetId);
        if (target) {
            target.parent().find(".tab").hide();
            target.show();
            $(this).parent().parent().find("a").removeClass("active");
            $(this).addClass("active");
        }
    });
});